'use client';

import {
  InverseHeader,
  type InverseHeaderProps,
} from '@jouzen/ecom-components/layout';

const InverseHeaderWrapper = (props: InverseHeaderProps) => {
  return <InverseHeader {...props} />;
};

export default InverseHeaderWrapper;
